import React, { useCallback, useMemo, useContext, useRef, useEffect } from 'react';
import T from 'prop-types';
import { get } from 'lodash-es';

import SelectedApp from './SelectedApp';
import PopularApps from '../../../shared/components/PopularApps';
import Button from '../../../../../../components/Buttons/Button';
import SearchTypeahead from '../../../../../../components/SearchTypeahead';
import { InitialDataContext } from '../../context';
import useMobileView from '../../../shared/hooks/useMobileView';

const filterSearchResults = results => results.filter(app => app.dls_30d !== 0);

const AppSelection = ({
  selectedApps,
  customTexts,
  onAppsChange,
  onStepChange,
}) => {
  const isMobileView = useMobileView();
  const hasSelectedApp = Boolean(selectedApps.length);
  const searchTypeahead = useRef();

  const searchTypeaheadRef = useCallback(() => searchTypeahead.current
    && searchTypeahead.current.typeaheadInstance(), []);

  const { popularApps } = useContext(InitialDataContext);
  const popularAppsChunk = useMemo(() => popularApps.slice(0, 5), [popularApps]);

  useEffect(() => {
    if (!hasSelectedApp) {
      searchTypeaheadRef().focus();
      searchTypeaheadRef().inputNode.select();
    }
  }, []);

  const handleAppRemove = useCallback(() => {
    onAppsChange([]);
  }, [onAppsChange]);

  const handleStepChange = () => {
    if (hasSelectedApp) {
      const mainHero = document.querySelector('.defaults-hero.paid-search-landing-page-hero-v2');
      if (mainHero) mainHero.classList.add('full-width');
      onStepChange('processing-smart-search');
    }
  };

  return (
    <div className="app-selection">
      <h3 className="app-selection__pretitle">
        {get(customTexts, 'preTitle') || 'Free Report on Your Competition'}
      </h3>
      <h1 className="app-selection__title">
        {get(customTexts, 'title') || 'Industry-Leading  Mobile Insights'}
      </h1>
      <h1 className="app-selection__single-desktop">
        Search for any app
      </h1>


      <div className="app-selection__search-app">
        {hasSelectedApp ? (
          <SelectedApp
            app={selectedApps[0]}
            size={isMobileView ? 24 : 32}
            onRemove={handleAppRemove}
          />
        ) : (
          <SearchTypeahead
            onChange={onAppsChange}
            decorateItems={filterSearchResults}
            searchAsset="apps"
            maxHeight={isMobileView ? '160px' : '210px'}
            placeholder="Search for your app"
            decorators={['dls_30d', 'big_icon_url']}
            minLength={1}
            disableSearchOnFocus
            disableRecentResults
            includesUnified
            clearButton
            ref={searchTypeahead}
            autoFocus={false}
          />
        )}

        <Button
          size="lg"
          className="app-selection__btn-submit"
          disabled={!hasSelectedApp}
          onClick={handleStepChange}
        >
          Generate Report
        </Button>
      </div>

      <PopularApps
        apps={popularAppsChunk}
        title="Run a report on popular apps"
        appSize={isMobileView ? 48 : 64}
        disabled={hasSelectedApp}
        className="app-selection__popular-apps"
        onAppSelect={onAppsChange}
      />
    </div>
  );
};

AppSelection.propTypes = {
  selectedApps: T.array.isRequired,
  customTexts: T.shape({
    preTitle: T.string,
    title: T.string,
  }),
  onAppsChange: T.func.isRequired,
  onStepChange: T.func.isRequired,
};

export default AppSelection;
